import React from "react";
import * as S from "./style";
import Svg from "@components/svg";
import { dashboard, food, statsdown, statsup, totalusers } from "@assets/icons";
import CardLoader from "@components/skeleton/dashboarcard";
import Typography from "@components/typography";
import theme from "@utils/theme";
const Analytic = ({
  icon,
  title,
  value,
  newCount,
  isUp,
  loading,
  onClick,
}: any) => {
  return (
    <>
      <S.StyleAnalyticCard
        onClick={onClick}
        $clickable={!!onClick}
        style={{ cursor: onClick ? "pointer" : "default" }}
      >
        <img src={icon} alt="" />
        <Typography size={16} styleText={`color:black`} weight={600}>
          {title}
        </Typography>
        <Typography size={28} weight={700} styleText={`color:black`}>
          {value || 0}
        </Typography>
        <Typography size={14}>
          <span style={{ fontWeight: 600 }}>{newCount || 0}</span> Newly added
        </Typography>
      </S.StyleAnalyticCard>
    </>
  );
};

export default Analytic;
